import moment from 'moment';
import React, { useState } from 'react';
import { BsCheck2All, BsInfoCircle, BsCheck2, BsX, BsHeadphones } from "react-icons/bs"; 

const Message = ({ text, media_type, media_url, time, isOutgoing, error_msg, status = 'sent' }) => {
  const [isOpen, setIsOpen] = useState(false); 

  const statusTick = () => {
    if (status === 'sent') return <BsCheck2 size={17} color="#8696a0" />;
    if (status === 'delivered') return <BsCheck2All size={17} color="#8696a0" />;
    if (status === 'read') return <BsCheck2All size={17} color="#259ce6" />;
    if (status === 'failed') return <BsInfoCircle title={error_msg} size={17} color="#ef4444" />;
  };

  return (
    <>
      <div className={`message ${isOutgoing ? 'outgoing' : 'incoming'}`}>
        
        {media_type === 'image' && media_url && (
          <div className="media-content" style={{ marginBottom: '5px' }}>
            <img
              src={media_url}
              alt="media"
              onClick={() => setIsOpen(true)}
              style={{ maxWidth: '200px', borderRadius: '8px', cursor: 'pointer', display: 'block' }}
            />
            {text && <div className="msg-text" style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>{text}</div>}
          </div>
        )}

        {media_type === 'audio' && media_url && (
          <div className="media-content audio-msg" style={{ padding: '5px 0' }}>
            <audio controls style={{ height: '35px', maxWidth: '220px' }}>
              <source src={media_url} type="audio/mpeg" />
              <source src={media_url} type="audio/ogg" />
              Your browser does not support the audio element.
            </audio>
            {text && text !== "Audio Message" && <div className="msg-text" style={{ marginTop: '5px' }}>{text}</div>}
          </div>
        )}

        {!media_type || media_type === 'text' ? (
          <div className="msg-text" style={{ whiteSpace: 'pre-wrap' }}>{text}</div>
        ) : null}

        <div className="msg-meta">
          <span className="time">{moment(time).format('DD-MM-YYYY h:mm A')}</span>
          {isOutgoing && (
            <div className="status-icon" style={{ display: 'flex' }}>
              {statusTick()}
            </div>
          )}
        </div>
      </div>

      {isOpen && (
        <div 
          onClick={() => setIsOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center',
            alignItems: 'center', zIndex: 9999, cursor: 'pointer'
          }}
        >
          <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
            <BsX 
              size={40} color="white" 
              style={{ position: 'absolute', top: '-40px', right: '0px', cursor: 'pointer' }} 
            />
            <img 
              src={media_url} 
              alt="fullsize" 
              style={{ width: '100%', height: 'auto', borderRadius: '8px', boxShadow: '0 0 20px rgba(0,0,0,0.5)' }} 
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Message;